import React from 'react';
import { TopNav } from './components/TopNav';
import { Hero } from './components/Hero';
import { ProgramJourney } from './components/ProgramJourney';
import { ValuesGrid } from './components/ValuesGrid';
import { WhatYouBuild } from './components/WhatYouBuild';
import { SkillsGrid } from './components/SkillsGrid';
import { MentorNetwork } from './components/MentorNetwork';
import { Outcomes } from './components/Outcomes';
import { ForParents } from './components/ForParents';
import { ForTeachers } from './components/ForTeachers';
import { FAQ } from './components/FAQ';
import { ApplySection } from './components/ApplySection';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { ApplyProvider } from './components/ApplyContext';
import { ApplyModal } from './components/ApplyModal';
export function App() {
  return <ApplyProvider data-id="element-0">
      <div className="min-h-screen bg-ivory text-charcoal font-sans selection:bg-gold/30 selection:text-navy" data-id="element-1">
        <TopNav data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <ProgramJourney data-id="element-5" />
          <ValuesGrid data-id="element-6" />
          <WhatYouBuild data-id="element-7" />
          <SkillsGrid data-id="element-8" />
          <MentorNetwork data-id="element-9" />
          <Outcomes data-id="element-10" />
          <ForParents data-id="element-11" />
          <ForTeachers data-id="element-12" />
          <FAQ data-id="element-13" />
          <ApplySection data-id="element-14" />
          <Contact data-id="element-15" />
        </main>
        <Footer data-id="element-16" />
        <StickyMobileCTA data-id="element-17" />
        <ApplyModal data-id="element-18" />
      </div>
    </ApplyProvider>;
}